import { render, staticRenderFns } from "./SportEventForm.vue?vue&type=template&id=543f278f&"
import script from "./SportEventForm.vue?vue&type=script&lang=js&"
export * from "./SportEventForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports